class HeroBanner {
  constructor(el) {
    this.el = el;
    this.slides = Array.from(el.querySelectorAll('.hero-banner__slide'));
    this.dots = Array.from(el.querySelectorAll('.hero-banner__dot'));
    this.prevBtn = el.querySelector('.hero-banner__arrow--prev');
    this.nextBtn = el.querySelector('.hero-banner__arrow--next');
    this.current = 0;
    this.autoplay = el.dataset.autoplay === 'true';
    this.speed = parseInt(el.dataset.autoplaySpeed, 10) || 6000;
    this.timer = null;

    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.current - 1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.current + 1));

    if (this.autoplay && this.slides.length > 1) this.startAutoplay();
    this.playActiveVideo();
  }

  goTo(index) {
    const total = this.slides.length;
    this.current = (index + total) % total;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.current);
      const video = slide.querySelector('video');
      if (video) {
        if (i === this.current) {
          video.currentTime = 0;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }
    });

    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.current));

    if (this.autoplay) this.restartAutoplay();
  }

  playActiveVideo() {
    const video = this.slides[this.current].querySelector('video');
    if (video) video.play().catch(() => {});
  }

  startAutoplay() {
    this.timer = setInterval(() => this.goTo(this.current + 1), this.speed);
  }

  restartAutoplay() {
    clearInterval(this.timer);
    this.startAutoplay();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.hero-banner').forEach((el) => new HeroBanner(el));
});